"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _illustrationName = require("../utils/propTypes/illustrationName");

var _UIAbstractIllustration = _interopRequireDefault(require("./UIAbstractIllustration"));

var UIIllustration = function UIIllustration(props) {
  return _react.default.createElement(_UIAbstractIllustration.default, props);
};

UIIllustration.defaultProps = _UIAbstractIllustration.default.defaultProps;
UIIllustration.propTypes = (0, _extends2.default)({}, _UIAbstractIllustration.default.propTypes, {
  name: (0, _illustrationName.getIllustrationNamePropType)().isRequired
});
UIIllustration.displayName = 'UIIllustration';
var _default = UIIllustration;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/image/UIIllustration.js
// module id = 152
// module chunks = 5 6